<template>
	<svg
		width="9px"
		height="12px"
		viewBox="0 0 9 12"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="pin icon"
	>
		<g
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
			opacity="0.7"
		>
			<g
				transform="translate(-347.000000, -8.000000)"
				:fill="color"
				fill-rule="nonzero"
			>
				<g transform="translate(347.000000, 8.000000)">
					<path
						d="M6.98501306,4.79360955 L6.69825599,2.14772465 L7.68747998,2.14772465 C7.99814323,2.14772465 8.24997852,1.90733609 8.24997852,1.61079349 L8.24997852,0.536931162 C8.24997852,0.240388556 7.99814323,0 7.68747998,0 L1.31249658,0 C1.00183333,0 0.749998047,0.240388556 0.749998047,0.536931162 L0.749998047,1.61079349 C0.749998047,1.90733609 1.00183333,2.14772465 1.31249658,2.14772465 L2.30172057,2.14772465 L2.0149635,4.79360955 C0.878083651,5.29816824 0,6.20291962 0,7.33805921 C0,7.63460182 0.251835282,7.87499037 0.562498535,7.87499037 L3.74999023,7.87499037 L3.74999023,10.2018487 C3.74999023,10.2296349 3.75676365,10.2570407 3.76979487,10.2818962 L4.33229341,11.3557585 C4.40122291,11.4873514 4.59863646,11.4875975 4.66770659,11.3557585 L5.23020513,10.2818962 C5.24322071,10.2570408 5.25000092,10.2296362 5.25000977,10.2018487 L5.25000977,7.87499037 L8.43750146,7.87499037 C8.74816472,7.87499037 9,7.63460182 9,7.33805921 C9,6.19298639 8.10977576,5.29279893 6.98501306,4.79360955 Z"
					></path>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'Pin',
	props: {
		color: {
			type: String,
			default: '#ffffff',
		},
	},
}
</script>
